// pwa user settings used when admin or slt edits student

import type { Settings } from '../types';
import { Role, Level } from '../enums'
import {
  defaultHelpDelaySecs, defaultShowRepeatButtonDelaySecs,
  sessionsBeforeLevelChange
} from '../constants';

class EditPWASettings {
  email = $state<string>("");
  name = $state<string>("");
  active = $state<boolean>(true);
  level = $state<Level>(Level.First);
  completedOnCurrentLevel = $state<number>(0);
  hasFreeLicenses = $state<boolean>(false);
  settings = $state<Settings>({
    helpDelaySecs: defaultHelpDelaySecs,
    repeatDelaySecs: defaultShowRepeatButtonDelaySecs,
    perseveration: false,
    doTestNextSession: false,
    doIntroNextSession: false,
    sessionsBeforeLevelChange: sessionsBeforeLevelChange,
    qwertyKeyboard: false,
    simpleSpelling: false
  });
  // to distinguish privat users on settings page
  pwaRole = $state<string>(Role.PWA);
}


export const editPWASettings = new EditPWASettings();